export default (context, inject) => {
  const tel = "+7##########"
  inject('maskaPatternTel', tel)
}
